import { Modal, Radio, Space } from 'antd';
import { RevxButton } from 'components/RevxButton';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './OrgTypeSelectModal.less';

export enum OrgTypeEnum {
  SAAS = 'SAAS',
  REGULAR = 'REGULAR',
  CUSTOMER = 'CUSTOMER',
}

interface OrgTypeSelectModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (orgType: OrgTypeEnum) => void;
  defaultType?: OrgTypeEnum;
}

const OrgTypeSelectModal: React.FC<OrgTypeSelectModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  defaultType = OrgTypeEnum.REGULAR,
}) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState<OrgTypeEnum>(defaultType);

  // 当模态框显示时，重置为默认类型
  useEffect(() => {
    if (visible) {
      setSelectedType(defaultType);
    }
  }, [visible, defaultType]);

  const handleConfirm = () => {
    onConfirm(selectedType);
  };

  return (
    <Modal
      title={t('platform.org.selectOrgType')}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <RevxButton key="cancel" onClick={onCancel}>
          {t('common.cancel')}
        </RevxButton>,
        <RevxButton
          key="confirm"
          type="primary"
          brandGreen
          onClick={handleConfirm}
        >
          {t('common.confirm')}
        </RevxButton>,
      ]}
      width={500}
      className="org-type-select-modal"
    >
      <div className="org-type-select-content">
        <p className="org-type-select-description">
          {t('platform.org.selectOrgTypeDescription')}
        </p>
        <Radio.Group
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          className="org-type-radio-group"
        >
          <Space direction="vertical" size={16}>
            <Radio value={OrgTypeEnum.SAAS} className="org-type-radio">
              <div className="org-type-option">
                <div className="org-type-title">
                  {t('platform.org.saasOrg')}
                </div>
                <div className="org-type-desc">
                  {t('platform.org.saasOrgDescription')}
                </div>
              </div>
            </Radio>
            <Radio value={OrgTypeEnum.REGULAR} className="org-type-radio">
              <div className="org-type-option">
                <div className="org-type-title">
                  {t('platform.org.regularOrg')}
                </div>
                <div className="org-type-desc">
                  {t('platform.org.regularOrgDescription')}
                </div>
              </div>
            </Radio>
          </Space>
        </Radio.Group>
      </div>
    </Modal>
  );
};

export default OrgTypeSelectModal;
